import { render, staticRenderFns } from "./rcptResourcesCard.vue?vue&type=template&id=439629e1"
import script from "./rcptResourcesCard.vue?vue&type=script&lang=js"
export * from "./rcptResourcesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports